import PropTypes from 'prop-types';
export const ViewAccountPropsInterface = {
  trackingSource: PropTypes.string.isRequired
};